var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"lucide lucide-move-up",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M8 6L12 2L16 6"}}),_c('path',{attrs:{"d":"M12 2V22"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }